type NavigationArrowIconProps = {
  direction: 'left' | 'right'
  strokeColor: 'black' | 'white'
}

export default function NavigationArrowIcon({
  direction,
  strokeColor,
}: NavigationArrowIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={direction === 'left' ? 'M10 4L6 8L10 12' : 'M6 4L10 8L6 12'}
        stroke={strokeColor}
        strokeWidth="1.6"
      />
    </svg>
  )
}
